// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".color-dots--tnwqz{display:inline-flex;align-items:center;flex-shrink:0}.color-dot--VOaBb{border-radius:50%;border:1px solid rgba(0,0,0,.1);flex-shrink:0}.size-sm--lgzFc{gap:2px}.size-sm--lgzFc .color-dot--VOaBb{width:10px;height:10px}.size-md--spspv{gap:4px}.size-md--spspv .color-dot--VOaBb{width:18px;height:18px}.fit-width--QXX82{flex-shrink:1;min-width:0}.fit-width--QXX82 .color-dot--VOaBb{flex-shrink:1;min-width:0;height:auto;aspect-ratio:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-dots": "color-dots--tnwqz",
	"color-dot": "color-dot--VOaBb",
	"size-sm": "size-sm--lgzFc",
	"size-md": "size-md--spspv",
	"fit-width": "fit-width--QXX82"
};
export default ___CSS_LOADER_EXPORT___;
